import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { PsTransferDashboardTable } from '../molecules/tables/PsTransferDashboardTable';

class PsTransferDashboard extends React.Component {
    state = {
        purchaseOrders: [],
        isLoaded: false,
        error: null
    };

    componentDidMount() {
        this._loadPurchaseOrders();
    }

    _loadPurchaseOrders() {
        const { client } = this.props;

        // Filter POs where vendor name starts with "PiShop" using MongoDB regex
        // and purchaseDate is after Jan 1, 2026
        const filterJson = JSON.stringify({
            "vendor.name": { "$regex": "^PiShop", "$options": "i" },
            "purchaseDate": { "$gt": "2026-01-01" }
        });

        client.purchaseOrders.getPurchaseOrders({ limit: 100, dateSort: -1, filterJson })
            .then(purchaseOrders => {
                this.setState({
                    purchaseOrders: purchaseOrders,
                    isLoaded: true
                });
            })
            .catch(error => {
                this.setState({
                    error,
                    isLoaded: true
                });
            });
    }

    render() {
        const { purchaseOrders, isLoaded, error } = this.state;

        return (
            <Container fluid className="mt-3">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <h4 className="mb-0">PiShop Inventory Transfers</h4>
                            </CardHeader>
                            <CardBody>
                                <PsTransferDashboardTable
                                    purchaseOrders={purchaseOrders}
                                    isLoaded={isLoaded}
                                    error={error}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

PsTransferDashboard.propTypes = {
    client: PropTypes.object.isRequired
};

export { PsTransferDashboard };
